import httpClient from '../httpClient';

export const getFavorites = async (idCustomer, idStore) => {
  const result = await httpClient.get('/favorites/get', {
    params: {
      idCustomer,
      idStore,
    },
  });
  return result.data;
};
export const addFavorites = async (
  idCustomer,
  idStyle,
  color,
  quantity,
  idStore,
) => {
  const result = await httpClient.post('/favorites/add', {
    idCustomer,
    idStyle,
    color,
    quantity,
    idStore,
  });
  return result.data;
};
export const updateFavorites = async (idCustomer, idStyle, quantity) => {
  const result = await httpClient.post('/favorites/set', {
    idCustomer,
    idStyle,
    quantity,
  });
  return result.data;
};

export const removeFavorites = async (idCustomer, idWishlist) => {
  const result = await httpClient.post('/favorites/remove', {
    idCustomer,
    idWishlist,
  });
  return result.data;
};

export const createCartFromFavorites = async (idCustomer) => {
  const result = await httpClient.post('/favorites/create-cart', {
    idCustomer: idCustomer,
  });
  return result.data;
};
